import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { withRouter } from 'react-router';
import { Button } from 'reactstrap';
import { MessageStore } from 'src/Stores/Messages/Messages';
import { RootStore } from 'src/Stores/Root/RootStore';
import { UserStore } from 'src/Stores/User/UserStore';
import { WellsStore } from 'src/Stores/Wells/WellsStore';

@inject('stores')
@observer
export class WellRevertCloseButton extends React.Component {

    public props: any;
    private RootStore: RootStore;
    private WellStore: WellsStore;
    private UserStore: UserStore;
    private MessageStore: MessageStore;

    constructor(props: any) {
        super(props);
        this.RootStore = this.props.stores;
        this.WellStore = this.RootStore.WellsStore;
        this.UserStore = this.RootStore.UserStore;
        this.MessageStore = this.RootStore.MessageStore;
    }

    private revertToActive = () => {
        const areYouSure = confirm("All adjustments made on the Well Close Review pages will be lost when you revert this well to the Active status.\n\nPress OK to revert this well to Active");
        if (areYouSure) {
            const well = this.WellStore.well;
            well.wellStatus = 'Active';
            this.WellStore.putWellModel(well)
            .then(data => {
                if (data) {
                    this.MessageStore.addMessage('Well Reverted to Active Status.', 'success');
                    if (this.props.match.path.includes('wellclose')) {
                        this.props.history.push(`/well/${well.id}/details`);
                    }
                    this.WellStore.clearWellCloseReview();
                }
            });
        }
    }

    private revertToFinishing = () => {
        const areYouSure = confirm("Are you sure you want to revert this well to the Finishing status?\n\nPress OK to continue");
        if (areYouSure) {
            const well = this.WellStore.well;
            well.wellStatus = 'Finishing';
            this.WellStore.putWellModel(well)
            .then(data => {
                if (data) {
                    this.MessageStore.addMessage('Well Reverted to Finishing Status.', 'success');
                }
            });
        }
    }

    private deleteWell = () => {
        const areYouSure = confirm("Are you sure you want to delete this well?");
        if (areYouSure) {
            const areYouReallySure = confirm("You are about to delete this Well and all of its data.\n\nPress OK to continue.");
            if (areYouReallySure) {
                this.WellStore.deleteWell().then((data) =>{
                    if (data) {
                        this.MessageStore.addMessage('Well Deleted.', 'success', 5000);
                        this.props.history.push('/home');
                    }
                });
            }
        }
    }

    private hasPermission = () => {
        if (this.UserStore.hasGenericPermission('Permissions.Wells.Close')) {
            if (!this.UserStore.hasPermission('Permissions.Wells.Close.All') && this.WellStore.well) {
                return this.WellStore.well.engineers.some(eng => eng.id === this.UserStore.user.id);
            } else {
                return true;
            }
        }
        return false;
    }

    public render() {

        const currWell = this.WellStore.well;
        if (!currWell) {
            return '';
        }
        
        if (!this.hasPermission()) {
            return '';
        }
        
        
        if (currWell.wellStatus === 'Finishing') {
            return <div className="float-left" style={{marginLeft: '220px'}}>
                <Button type="button" color="danger" onClick={this.revertToActive}>Revert to Active</Button>
                {this.UserStore.hasPermission('Permissions.Wells.Delete') && <Button type="button" color="danger" onClick={this.deleteWell}>Delete Well</Button>}
                </div>
            ;
        }
        
        if (currWell.wellStatus === 'Closed') {
            return <div className="float-left" style={{marginLeft: '220px'}}>
                <Button type="button" color="danger" onClick={this.revertToFinishing}>Revert to Finishing</Button>
                {this.UserStore.hasPermission('Permissions.Wells.Delete') && <Button type="button" color="danger" onClick={this.deleteWell}>Delete Well</Button>}
                </div>
            ;
        }

        if (this.UserStore.hasPermission('Permissions.Wells.Delete')) {
            return <div className="float-left" style={{marginLeft: '220px'}}><Button type="button" color="danger" onClick={this.deleteWell}>Delete Well</Button></div>;
        }
        return '';


    }

}

export default withRouter(WellRevertCloseButton);


// WEBPACK FOOTER //
// ./src/Components/Main/WellWorkflow/WellRevertCloseButton.tsx